import { render, staticRenderFns } from "./richTextList.vue?vue&type=template&id=53168015&scoped=true"
import script from "./richTextList.vue?vue&type=script&lang=js"
export * from "./richTextList.vue?vue&type=script&lang=js"
import style0 from "./richTextList.vue?vue&type=style&index=0&id=53168015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53168015",
  null
  
)

export default component.exports